export default __webpack_public_path__ + "static/media/mobile2.c68f6bfa.webp";